
//sec 6

const tabsS6 = document.querySelectorAll('.co--home-s6--right-tab');
const imagesS6 = document.querySelectorAll('.co--home-s6--middle-image');

tabsS6.forEach((tab, index) => {
    tab.addEventListener('click', () => {

        // Remove active from all tabs
        tabsS6.forEach(t => t.classList.remove('active'));

        // Remove active from all images
        imagesS6.forEach(img => img.classList.remove('active'));

        // Add active to clicked tab
        tab.classList.add('active');

        // Add active to corresponding image
        if (imagesS6[index]) {
            imagesS6[index].classList.add('active');
        }

        gsap.set(".co--home-s6--left-wrapper img", {clearProps:"x,y"});
    });
});

Draggable.create(".co--home-s6--left-wrapper img", {
    type: "x,y",
    edgeResistance: 0.65,
    bounds: ".co--home-s6--wrapper-inner",
    inertia: true
});


//sec 6